export default "__VITE_ASSET__efbb467f__"